//After DOM is loaded
document.addEventListener("DOMContentLoaded", function() {
    // Select all video sections
    const volumeOn = document.querySelectorAll('.volume-on');
    const volumeOff = document.querySelectorAll('.volume-off');
    
    // add click event listener to each volume on button
    volumeOn.forEach(button => {
        button.addEventListener('click', function() {
            const video = this.closest('.video-section-1').querySelector('.video-wrapper video');
            console.log("video", video, "on");
            video.muted = true;
            this.classList.remove('show');
            this.nextElementSibling.classList.add('show');
        });
    });

    // add click event listener to each volume off button
    volumeOff.forEach(button => {
        button.addEventListener('click', function() {
            const video = this.closest('.video-section-1').querySelector('.video-wrapper video');
            console.log("video", video, "off");
            video.muted = false;
            this.classList.remove('show');
            this.previousElementSibling.classList.add('show');
        });
    });
});